import PropTypes from "prop-types";

export default PropTypes.arrayOf(
  PropTypes.shape({
    id: PropTypes.number,
    name: PropTypes.string,
    agentLink: PropTypes.string,
    company: PropTypes.string,
    activeSince: PropTypes.string,
    psl: PropTypes.bool,
    disengageUrl: PropTypes.string,
    cvsSubmitted: PropTypes.number,
    avatar: PropTypes.string,
    starRatingPercent: PropTypes.number,
  })
);
